import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IErrorData from "../../../core/src/server/data/errorData";

export default class ErrorDataParser implements IBaseDataParser<IErrorData> {
    public check(data: any): boolean {
        return data?.data?.error;
    }

    public parse(data: any): IErrorData[] {

       const result: IErrorData = {
            errorCode: data?.data?.error,
            errorMessage: data?.data?.error,
            critical: true,
            rawError: data
       }

       return [result];
    }

}